/**
 * Vendor-only Brand Admin console — build-time visibility gate for the
 * frontend.
 *
 * Fail-closed (opposite of the feature-flags convention in
 * featureFlags.js): hidden unless REACT_APP_BRAND_ADMIN_ENABLED is
 * literally the string "true" in the build's environment. No client
 * .env.production ever sets this, so the sidebar entry, route, and
 * screen are structurally absent from every client build — the frontend
 * mirror of the backend's env-gated BrandAdminEnabledGuard
 * (BRAND_ADMIN_ENABLED, see
 * backend/src/modules/brand-admin/guards/brand-admin-enabled.guard.ts).
 */
export function isBrandAdminUiEnabled() {
  return process.env.REACT_APP_BRAND_ADMIN_ENABLED === "true";
}

export default isBrandAdminUiEnabled;
